const CHAT_EXTENSION_LAB_ROUTE = /^\/(en|ru|ua|de)\/chat-extension-lab\/?$/;

/** Exact shared matcher for Express paths and Angular router URLs. */
export function isChatExtensionLabRoute(url: string): boolean {
  const pathname = url.split(/[?#]/, 1)[0] ?? '';
  return CHAT_EXTENSION_LAB_ROUTE.test(pathname);
}
